var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinaShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 12.1562C5.69975 12.1562 6.875 10.981 6.875 9.53125C6.875 8.0815 5.69975 6.90625 4.25 6.90625C2.80025 6.90625 1.625 8.0815 1.625 9.53125C1.625 10.981 2.80025 12.1562 4.25 12.1562Z",
    stroke: "#676767",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 18.0625C14.8872 18.0625 16.0625 16.8872 16.0625 15.4375C16.0625 13.9878 14.8872 12.8125 13.4375 12.8125C11.9878 12.8125 10.8125 13.9878 10.8125 15.4375C10.8125 16.8872 11.9878 18.0625 13.4375 18.0625Z",
    stroke: "#676767",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 6.25C14.8872 6.25 16.0625 5.07475 16.0625 3.625C16.0625 2.17525 14.8872 1 13.4375 1C11.9878 1 10.8125 2.17525 10.8125 3.625C10.8125 5.07475 11.9878 6.25 13.4375 6.25Z",
    stroke: "#676767",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2299 5.04395L6.45801 8.11156",
    stroke: "#676767",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45801 10.9502L11.2299 14.0178",
    stroke: "#676767",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinaShare);
export default __webpack_public_path__ + "v10/media/bina-share.94042720015bc39f237434bc3d592c35.svg";
export { ForwardRef as ReactComponent };